import React, { FC, useEffect, useState, Dispatch, SetStateAction, useContext } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import SelectSettings, { MenuContents } from '../../organisms/SelectSettings';

import PartialDischargePage from './PartialDischargeGrid/PartialDischargePage';
import PartialDischargeGraphPage from './PartialDischargeGraph/PartialDischargeGraphPage';

import { useTranslation } from 'react-i18next';
import { AppContext } from '../../../App';

type PartialDischargeSettingProps = {}

const useStyles = makeStyles(
    createStyles({
        tableContainer: {
            maxHeight: 'calc(100vh - 350px)',
        },
    })
);

const PartialDischargeSettingPage: React.FC<PartialDischargeSettingProps> = (props: PartialDischargeSettingProps) => {
    const { t } = useTranslation();
    const classes = useStyles();
    console.log('== PartialDischargeSettingPage ==');
    const { login } = useContext(AppContext);

    const menuList: MenuContents[] = [];

    menuList.push({
        name: t('PartialDischargeSettingPage.部分放電_状態一覧表示', '部分放電 状態一覧表示'),
        component: PartialDischargePage,
        tag: 'PartialDischarge',
    });
    menuList.push({
        name: t('PartialDischargeSettingPage.部分放電グラフ', '部分放電グラフ'),
        component: PartialDischargeGraphPage,
        tag: 'PartialDischargeGraph',
    });
    return (
        <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ marginRight: 0 }}>
            <SelectSettings menuList={menuList} />
        </Grid>
    );
};
export default PartialDischargeSettingPage;